import React, { useState, useEffect } from "react";
import {
  Tag,
  Classes,
  Drawer,
  Button,
  Collapse,
  Callout,
  Icon,
  Checkbox,
  FormGroup,
  ControlGroup,
  H6,
  H5,
  Divider,
  InputGroup,
} from "@blueprintjs/core";
import { Trans } from "react-i18next";
import {
  authenticatedPostFetch,
  authenticatedGetFetch,
  authenticatedPutFetch,
  authenticatedDeleteFetch,
} from "../../utils/AuthenticatedFetch";

import { TimePicker } from "@blueprintjs/datetime";
import { MultiContactSelect } from "./ContactSelector";

function CollapseIcon(val) {
  return val ? <Icon icon="chevron-up" /> : <Icon icon="chevron-down" />;
}

function PlanningCall(props) {
  const [Open, setOpen] = useState(false);
  const [Name, setName] = useState(props.name);
  const [Monday, setMonday] = useState(props.Monday || false);
  const [Tuesday, setTuesday] = useState(props.Tuesday || false);
  const [Wednesday, setWednesday] = useState(props.Wednesday || false);
  const [Thursday, setThursday] = useState(props.Thursday || false);
  const [Friday, setFriday] = useState(props.Friday || false);
  const [Saturday, setSaturday] = useState(props.Saturday || false);
  const [Sunday, setSunday] = useState(props.Sunday || false);
  const [StartHours, setStartHours] = useState(props.StartHours || "0");
  const [StartMinutes, setStartMinutes] = useState(props.StartMinutes || "0");
  const [StopHours, setStopHours] = useState(props.StopHours || "0");
  const [StopMinutes, setStopMinutes] = useState(props.StopMinutes || "0");
  const [Contacts, setContacts] = useState(props.contacts);

  return (
    <div>
      <Button
        rightIcon={CollapseIcon(Open)}
        alignText="left"
        fill={true}
        onClick={() => setOpen(!Open)}
      >
        <Trans>{props.name}</Trans>
      </Button>
      <Collapse isOpen={Open}>
        <FormGroup label={<Trans>label</Trans>} labelFor="name">
          <InputGroup
            type="text"
            id="name"
            value={Name}
            onChange={(ti) => {
              setName(ti.target.value);
            }}
          />
        </FormGroup>
        <FormGroup
          label={
            <H5>
              <Trans>days</Trans>
            </H5>
          }
        >
          <Checkbox
            inline={true}
            checked={Monday}
            label={<Trans>monday</Trans>}
            onChange={() => setMonday(!Monday)}
          />
          <Checkbox
            inline={true}
            checked={Tuesday}
            label={<Trans>tuesday</Trans>}
            onChange={() => setTuesday(!Tuesday)}
          />
          <Checkbox
            inline={true}
            checked={Wednesday}
            label={<Trans>wednesday</Trans>}
            onChange={() => setWednesday(!Wednesday)}
          />
          <Checkbox
            inline={true}
            checked={Thursday}
            label={<Trans>thursday</Trans>}
            onChange={() => setThursday(!Thursday)}
          />
          <Checkbox
            inline={true}
            checked={Friday}
            label={<Trans>friday</Trans>}
            onChange={() => setFriday(!Friday)}
          />
          <Checkbox
            inline={true}
            checked={Saturday}
            label={<Trans>saturday</Trans>}
            onChange={() => setSaturday(!Saturday)}
          />
          <Checkbox
            inline={true}
            checked={Sunday}
            label={<Trans>sunday</Trans>}
            onChange={() => setSunday(!Sunday)}
          />
        </FormGroup>
        <FormGroup
          label={
            <H5>
              <Trans>time slot</Trans>
            </H5>
          }
        >
          <ControlGroup>
            <ControlGroup vertical={true}>
              <H6>
                <Trans>start</Trans>
              </H6>
              <TimePicker
                showArrowButtons={true}
                value={
                  new Date(
                    new Date().setHours(
                      parseInt(StartHours, 10),
                      parseInt(StartMinutes, 10)
                    )
                  )
                }
                onChange={(time) => {
                  setStartHours(time.getHours().toString(10));
                  setStartMinutes(time.getMinutes().toString(10));
                }}
              />
            </ControlGroup>
            <ControlGroup vertical={true}>
              <H6>
                <Trans>stop</Trans>
              </H6>
              <TimePicker
                showArrowButtons={true}
                value={
                  new Date(
                    new Date().setHours(
                      parseInt(StopHours, 10),
                      parseInt(StopMinutes, 10)
                    )
                  )
                }
                onChange={(time) => {
                  setStopHours(time.getHours().toString(10));
                  setStopMinutes(time.getMinutes().toString(10));
                }}
              />
            </ControlGroup>
          </ControlGroup>
        </FormGroup>
        <FormGroup
          label={
            <H5>
              <Trans>call list</Trans>
            </H5>
          }
        >
          <MultiContactSelect
            initSelection={Contacts}
            onSelect={(contacts) => {
              console.log(contacts, "SELECTED");
              setContacts(contacts);
            }}
          />
        </FormGroup>

        <Button
          icon="trash"
          onClick={() =>
            authenticatedDeleteFetch(
              "/phonie/planning",
              { id: props.id },
              () => {
                props.refresh();
              }
            )
          }
        />
        <Button
          icon="floppy-disk"
          onClick={() =>
            authenticatedPutFetch(
              "/phonie/planning",
              {
                id: props.id,
                name: Name,
                monday: Monday,
                tuesday: Tuesday,
                wednesday: Wednesday,
                thursday: Thursday,
                friday: Friday,
                saturday: Saturday,
                sunday: Sunday,
                starthour: StartHours,
                startmin: StartMinutes,
                stophour: StopHours,
                stopmin: StopMinutes,
                contacts: Contacts,
              },
              () => props.refresh()
            )
          }
        />
      </Collapse>
    </div>
  );
}

export default function CallPlannings(props) {
  const [Open, setOpen] = useState(false);
  const [DefaultPlanning, setDefaultPlanning] = useState(false);
  const [PlanningsComp, setPlanningsComp] = useState(undefined);
  const [defaultContacts, setDefaultContacts] = useState([]);

  function refresh() {
    authenticatedGetFetch("/phonie/plannings", (data) => {
      if (data.length === 0)
        data = [
          {
            id: 0,
            name: "default",
            contacts: [],
          },
        ];
      setDefaultContacts(data[0].contacts);
      const temp_plannings = [];
      for (const planning of data.slice(1)) {
        // ignore default
        if (planning.name !== "planning") {
          temp_plannings.push(
            <PlanningCall
              {...planning}
              key={planning.id}
              refresh={() => refresh()}
            />
          );
        }
      }
      setPlanningsComp(temp_plannings);
    });
  }

  useEffect(() => {
    if (Open) refresh();
  }, [Open]);

  return (
    <div>
      <Tag
        large={true}
        round={true}
        icon="calendar"
        interactive={true}
        onClick={() => setOpen(true)}
      />
      <Drawer
        isOpen={Open}
        onClose={() => setOpen(false)}
        icon="calendar"
        title={<Trans>call planning</Trans>}
        isCloseButtonShown={true}
        canOutsideClickClose={true}
        canEscapeKeyClose={true}
        autoFocus={false}
        enforceFocus={true}
      >
        <div className={Classes.DRAWER_BODY}>
          <Callout className={Classes.DRAWER_FOOTER} icon={null}>
            <Button
              style={{ marginBottom: "10px" }}
              rightIcon={CollapseIcon(DefaultPlanning)}
              alignText="left"
              fill={true}
              onClick={() => setDefaultPlanning(!DefaultPlanning)}
            >
              <Trans>default planning</Trans>
            </Button>
            <Collapse isOpen={DefaultPlanning}>
              <FormGroup label={<Trans>call list</Trans>}>
                <ControlGroup fill={true}>
                  <MultiContactSelect
                    initSelection={defaultContacts}
                    onSelect={(contacts) => {
                      setDefaultContacts(contacts);
                    }}
                  />
                </ControlGroup>
              </FormGroup>
              <Button
                icon="floppy-disk"
                onClick={() =>
                  authenticatedPutFetch(
                    "/phonie/planning",
                    {
                      id: 1,
                      name: "default planning",
                      contacts: defaultContacts,
                    },
                    () => {
                      refresh();
                    }
                  )
                }
              />
            </Collapse>
            {PlanningsComp}
            <Divider />
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "5px",
              }}
            >
              <Button
                icon="plus"
                onClick={() =>
                  authenticatedPostFetch(
                    "/phonie/planning",
                    {
                      name: "new planning",
                      contacts: [],
                    },
                    () => {
                      refresh();
                    }
                  )
                }
              ></Button>
            </div>
          </Callout>
        </div>
      </Drawer>
    </div>
  );
}
